import { useEffect, useState } from "react";
export default function useIsAddToCartVisible(id = "add-to-cart-btn",data) {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const target = document.getElementById(id);

        console.log("Add to Cart visibility:", !target);
        if (!target) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    setIsVisible(entry.isIntersecting);
                });
            },
            { threshold: 0.5 }
        );

        observer.observe(target);
        return () => observer.disconnect();
    }, [id,isVisible,data]);

    return isVisible;
}
